module.exports = __webpack_public_path__ + "img/278.88f9373a.png";